/* global axios */
import ApiClient from './ApiClient';

// [PROSPEK] 2026-06-19 Send WhatsApp group exclusion only when the summary toggle is enabled
const excludeWhatsappGroupsParam = excludeWhatsappGroups =>
  excludeWhatsappGroups ? { exclude_whatsapp_groups: true } : {};
// [/PROSPEK]

class SummaryReportsAPI extends ApiClient {
  constructor() {
    super('summary_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getTeamReports({ since, until, businessHours, excludeWhatsappGroups } = {}) {
    return axios.get(`${this.url}/team`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        // [PROSPEK] 2026-06-19 Add report-level WhatsApp group exclusion API support
        ...excludeWhatsappGroupsParam(excludeWhatsappGroups),
        // [/PROSPEK]
      },
    });
  }

  getAgentReports({ since, until, businessHours, excludeWhatsappGroups } = {}) {
    return axios.get(`${this.url}/agent`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        // [PROSPEK] 2026-06-19 Add report-level WhatsApp group exclusion API support
        ...excludeWhatsappGroupsParam(excludeWhatsappGroups),
        // [/PROSPEK]
      },
    });
  }

  getInboxReports({ since, until, businessHours, excludeWhatsappGroups } = {}) {
    return axios.get(`${this.url}/inbox`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        // [PROSPEK] 2026-06-19 Add report-level WhatsApp group exclusion API support
        ...excludeWhatsappGroupsParam(excludeWhatsappGroups),
        // [/PROSPEK]
      },
    });
  }

  getLabelReports({ since, until, businessHours, excludeWhatsappGroups } = {}) {
    return axios.get(`${this.url}/label`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        // [PROSPEK] 2026-06-19 Add report-level WhatsApp group exclusion API support
        ...excludeWhatsappGroupsParam(excludeWhatsappGroups),
        // [/PROSPEK]
      },
    });
  }
}

export default new SummaryReportsAPI();
